<template >
<div>
        <v-file-input
            dense=""
            accept="image/png, image/jpeg, image/bmp"
            outlined
            rounded
            multiple
            chips
            prepend-inner-icon="mdi-paperclip"
            prepend-icon
            label="Subir Video"
            v-model="info"
            @change="data(info, uid)"
        ></v-file-input>
    </div>
</template>

<script>
export default {
    props: ["data", "uid", "content"],
    data() {
        return {
            info: this.content
        };
    },
    watch: {
        content() {
            this.info = this.content;
        }
    }
};
</script>

<style></style>
